module.exports = __webpack_public_path__ + "assets/shentong.68cc706e.svg";